/**
 * @generated SignedSource<<b883dc6652bc45f9851488fc68ad4fe9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPickerClassicProject$data = {
  readonly __typename: "Project";
  readonly closed: boolean;
  readonly columns: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  };
  readonly id: string;
  readonly number: number;
  readonly title: string;
  readonly url: string;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "ProjectPickerClassicProject";
};
export type ProjectPickerClassicProject$key = {
  readonly " $data"?: ProjectPickerClassicProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerClassicProject">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ProjectPickerClassicProject"
};

(node as any).hash = "14f14de63a019fba17a8d8d2bf169f64";

export default node;
